import * as React from "react";
import { useState, useCallback, useMemo } from "react";
import useIsMountedRef from "hooks/useIsMountedRef";
import FormWarningsContext from "./FormWarningsContext";
const FormWarningsProvider = ({ children }) => {
  const isMountedRef = useIsMountedRef();
  const [warnings, setWarnings] = useState({});
  const setFieldWarning = useCallback(
    (fieldName, warning) => {
      if (isMountedRef.current === true) {
        setWarnings((curWarnings) => ({ ...curWarnings, [fieldName]: warning }));
      }
    },
    [isMountedRef]
  );
  const formWarningsContextValue = useMemo(() => ({ warnings, setFieldWarning }), [setFieldWarning, warnings]);
  return /* @__PURE__ */ React.createElement(FormWarningsContext.Provider, { value: formWarningsContextValue }, children);
};
export default FormWarningsProvider;
